import { fromJS } from 'immutable';


export const serializeFiltersToLS = (payload) => (
  JSON.stringify(payload.toObject())
);

export const deserializeFiltersFromLS = fromJS;

export const getMyUsernameFilter = (username) => ({
  name: username,
  label: `My tests (${username})`,
  type: 'user',
});

export const getUsernameFilter = (username) => ({
  name: username,
  label: username,
  type: 'user',
});
